var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71591 10.9731C5.59676 11.1043 5.39042 11.1042 5.27144 10.9728L0.330053 5.51694C0.155402 5.3241 0.292225 5.01556 0.552396 5.01555L2.94951 5.01543C3.11519 5.01543 3.2495 4.88111 3.2495 4.71543V0.300001C3.2495 0.134315 3.38381 0 3.5495 0L7.4495 0C7.61519 0 7.7495 0.134315 7.7495 0.3V4.71573C7.7495 4.88142 7.88382 5.01574 8.04951 5.01573L10.4472 5.01562C10.7076 5.0156 10.8444 5.32451 10.6694 5.51728L5.71591 10.9731Z",
    fill: "#E4E4EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArrow);
export default __webpack_public_path__ + "static/media/VectorArrow.d02834ecc88ce889d9168a61264e4e1d.svg";
export { ForwardRef as ReactComponent };